/* unplugin-vue-components disabled */import script from "./onevideo.vue?vue&type=script&setup=true&name=onevideo&lang=js"
export * from "./onevideo.vue?vue&type=script&setup=true&name=onevideo&lang=js"

import "./onevideo.vue?vue&type=style&index=0&id=b189306c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b189306c"]])

export default __exports__